
export const roofTiltValuesConst: string[] = ['0°','15°','30°','45°'];


export const roofAzimuthConst: string[] = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW', 'N'];
